<template>
  <base-content-block :back-name="'hospitals'">
    <template #title>{{ $t('src/pages/hospitalsadd.55') }}</template>
    <template #content>
      <hospital-form v-model="hospital" :saving="saving" @submit="saveHospital"></hospital-form>
    </template>
  </base-content-block>
</template>

<script>
import http from '@/modules/http.js'
import { contentTpl } from '@/mixins/content-tpl.js'

export default {
  name: 'HospitalsAdd',
  mixins: [contentTpl],
  components: {
    HospitalForm: () => import('@/components/HospitalForm.vue')
  },
  data: () => ({
    hospital: {},
    saving: false
  }),
  methods: {
    saveHospital() {
      this.saving = true

      http
        .post('/hospitals', this.hospital)
        .then(hospital => {
          this.$router.push({
            name: 'user-add',
            query: { hospital: hospital.data.id }
          })
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => (this.saving = false))
    }
  }
}
</script>
